require('./addSnapshotScriptDialog.style.scss');


class AddSnapshotScriptDialogController {
    constructor($scope, $element, $timeout, $attrs, $filter, validationsService) {
        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
        this.$attrs = $attrs;
        this.$filter = $filter;
        this.validationsService = validationsService;
    };

    $onInit() {
        this.id = this.$attrs.eventId + '-close';
        this.closeId = { close: this.$attrs.eventId + '-close', closeIcon: this.$attrs.eventId + '-close-icon', closeTitle: this.$filter('translate')('common.form.default.btn.close.label') };
        this.setActionButtons();
    }

    setActionButtons() {
        this.actionButtons = [
            {
                title: this.$filter('translate')('toolbar.default.save.label'),
                action: () => this.save(),
                isDisabled: () => this.isDisabled(),
            }
        ];
    }

    onOpen() {
        this.modalTitle = this.modalTitle;
        this.preSnapshotScript = "";
        this.postSnapshotScript = "";
    }

    save() {
        let script = this.snapshotDialogType === 'pre' ? this.preSnapshotScript : this.postSnapshotScript;
        this.onSave({ script: script });
    }

    isDisabled() {
        if (this.preSnapshotScript || this.postSnapshotScript) {
            return false;
        }
        return true;
    }
}

AddSnapshotScriptDialogController.$inject = ['$scope', '$element', '$timeout', '$attrs', '$filter', 'validationsService'];

const addSnapshotScriptDialogComponent = {
    controller: AddSnapshotScriptDialogController,
    template: require('./addSnapshotScriptDialog.template.html'),
    bindings: {
        showModal: '=',
        onClose: '&',
        onSave: '&',
        isSubModal: '<?',
        modalTitle: '@',
        snapshotDialogType: '<'
    }
};

module.exports = addSnapshotScriptDialogComponent;


// WEBPACK FOOTER //
// ./src/azurebackup/views/virtualMachines/dialogs/addSnapshotScriptDialog/addSnapshotScriptDialog.component.js